import React from 'react';

// Status tabs for the marketing list pages, styled by the ops kit (.ops-tabs).
// `tabs` is a list of [key, label] pairs; `counts` is keyed the same way.
export default function Tabs({ tabs, active, counts, onChange }) {
  return (
    <div className="ops-tabs" role="tablist">
      {tabs.map(([k, l]) => (
        <button key={k} type="button" role="tab" aria-selected={active === k}
          className={active === k ? 'is-active' : ''} onClick={() => onChange(k)}>
          {l} <span className="count">{counts[k] || 0}</span>
        </button>
      ))}
    </div>
  );
}
